import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

const VALID_ORGANIZATIONS = [
  process.env.REACT_APP_ORGANIZATION_SYMBOL
];

const OrganizationRoute = () => {
  const { organization_symbol } = useParams();

  if (!VALID_ORGANIZATIONS.includes(organization_symbol)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default OrganizationRoute;